module.exports = __webpack_public_path__ + "img/can1.f56e6da4.png";